export default __webpack_public_path__ + "8926c71143ea3870c465af223c3cd1a2.svg";